<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h1>Privacy Policy</h1>
            <!-- <p>we are here for you</p> -->
        </div>
    </div>
</div>

<section class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="about-content">
                    <!-- <span class="sub-title">How we are Founded</span>
                    <h2>Take your business to the next level</h2> -->
                    <h2>Your privacy is important to us.</h2>
                    <p>It is Webstazy One Private Limited's policy to respect your privacy regarding any information we may collect from you across our website, <a routerLink="/">Webstazy One</a>, and other sites we own and operate.
                    </p>
                    <p>We only ask for personal information when we truly need it to provide a service to you.</p>
                    <p>We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.</p>
                    <p>We only retain collected information for as long as necessary to provide you with your requested service.</p>
                    <p>What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.</p>
                    <p>We don’t share any personally identifying information publicly or with third-parties, except when required to by law.</p>
                    <p>Our website may link to external sites that are not operated by us.</p>
                    <p>Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.</p>
                    <p>You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.</p>
                    <p>Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information.</p>
                    <p>If you have any questions about how we handle user data and personal information, feel free to <a routerLink="/contact">contact us</a>.</p>
                    <p><b>This policy is effective as of 17 July 2020.</b></p>

                </div>
            </div>
            <!-- <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img src="assets/img/about-img.jpg" alt="image">
                </div>
            </div> -->
        </div>
    </div>
</section>
